<div class="progress">
  <div class="progress-bar">
    <div class="progress-value" [style.width]="getWidth() + '%'">
      <div class="progress-value-animation"></div>
    </div>
  </div>
</div>
